export default {
  appTitle: 'LoanKnow - Dev',
  apiUrl: 'https://devapi.loanknow.com/api',
  appEnv: 'staging',
  isDevelopment: false,
  isStaging: true,
  isProduction: false,
};
